import {makeStyles} from "@material-ui/core/styles";
import InputBase from '@material-ui/core/InputBase';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
    root: {
        background: '#0693E3',
        padding: theme.spacing(2),
        borderBottomLeftRadius: 16,
        borderBottomRightRadius: 16,
        '& .MuiInputBase-root': {
            marginTop: 8,
            color: "#000",
            width: '100%',
            outline: 0,
            padding: theme.spacing(2),
            '@media (max-width:1366px)': {
                padding: theme.spacing(1),
            },
            background: '#F4F4F4',
            height: 100,
            borderRadius: 8,
            boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
        },
        '& .Mui-disabled': {
            background: '#aaa',
        },
    },
}))
export default function AdditionalNotes({value, disabled, onChange}) {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <Typography variant="caption" gutterBottom>
If there is anything else that we need to take into consideration, please add the details below. 
            </Typography>
            <InputBase
                fullWidth variant="filled"
                label="Additional Information"
                multiline rows={3}
                placeholder="Additional information"
                disabled={disabled}
                value={value}
                onChange={(e) => onChange(e.target.value)}
            />
        </div>

    )
}
